import {ForgotPasswordRecoverUserInfo} from 'domain/usecases';
import {RemoteForgotPasswordRecoverUserInfo} from 'data/usecases';
import {makeBFFApiUrl} from 'main/factories/http';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {EntryFlowEndPoints} from 'main/factories/usecases/endpoints';

export const makeForgotPasswordRecoverUserInfo = (): ForgotPasswordRecoverUserInfo =>
	new RemoteForgotPasswordRecoverUserInfo(
		makeBFFApiUrl(EntryFlowEndPoints.forgotRecoverUserInfo),
		makeAuthorizeHttpClientDecorator(),
	);
